// Baseline subheadings the user has deliberately deleted while filling in a
// care plan.
//
// Care Management and Review Care Plan each auto-add a row for every subheading
// that has a baseline score. Deleting a row only changes that page's local
// state, so navigating between the two pages used to resurrect the row. We keep
// the deleted ids in sessionStorage — both pages read it without prop-drilling,
// and it survives a refresh mid-flow, unlike router state.

const storageKey = (patientId) => `removedBaselineSubheadings:${patientId}`;

export function getRemovedBaselineSubheadings(patientId) {
  if (!patientId) return new Set();
  try {
    const raw = sessionStorage.getItem(storageKey(patientId));
    return new Set(raw ? JSON.parse(raw) : []);
  } catch (error) {
    return new Set();
  }
}

function persist(patientId, ids) {
  try {
    sessionStorage.setItem(storageKey(patientId), JSON.stringify([...ids]));
  } catch (error) {
    // Storage unavailable (private mode / quota) — the rows simply reappear,
    // which is the pre-existing behaviour.
  }
}

export function addRemovedBaselineSubheading(patientId, subheadingId) {
  if (!patientId || !subheadingId) return;
  const ids = getRemovedBaselineSubheadings(patientId);
  ids.add(subheadingId);
  persist(patientId, ids);
}

// Called when the user picks a subheading again from the dropdown, so a later
// pass through the flow re-populates its scores as normal.
export function restoreRemovedBaselineSubheading(patientId, subheadingId) {
  if (!patientId || !subheadingId) return;
  const ids = getRemovedBaselineSubheadings(patientId);
  if (!ids.delete(subheadingId)) return;
  persist(patientId, ids);
}

export function clearRemovedBaselineSubheadings(patientId) {
  if (!patientId) return;
  try {
    sessionStorage.removeItem(storageKey(patientId));
  } catch (error) {
    // Nothing to do — see persist().
  }
}
